import { createAction } from "@reduxjs/toolkit";

export const setDeeplinkData = createAction("deeplink/setDeeplinkData");
export const clearDeeplinkData = createAction("deeplink/clearDeeplinkData");
export const setDeeplinkLoading = createAction("deeplink/setDeeplinkLoading");
